import { render, staticRenderFns } from "./ProductReplicaDetail.vue?vue&type=template&id=52fac3f6&scoped=true"
import script from "./ProductReplicaDetail.vue?vue&type=script&lang=js"
export * from "./ProductReplicaDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fac3f6",
  null
  
)

export default component.exports